










import { Component, Vue } from 'vue-property-decorator'
import Validatable from '@/mixins/Validatable'
import Focusable from '@/mixins/Focusable'

type ValidatableAndFocusable = Validatable & Focusable

@Component
export default class ValidationForm extends Vue {
	async validate() {
		let isComponentFocused = false
		let isValid = true
		const validations: Array<Promise<boolean>> = []
		this.forEachChild(this, (child: ValidatableAndFocusable) => {
			if (child.validate instanceof Function) {
				const promise: Promise<boolean> = new Promise(async (resolve) => {
					const result = await child.validate()
					if (!result && !isComponentFocused && child.focus instanceof Function) {
						child.focus()
						isComponentFocused = true
					}
					resolve(result)
				})
				validations.push(promise)
			}
		})
		const results = await Promise.all(validations)
		if (results.indexOf(false) >= 0) isValid = false
		this.$emit('validate', isValid)
		return isValid
	}

	resetValidation() {
		this.forEachChild(this, (child: Validatable) => {
			if (child.resetValidation instanceof Function) {
				child.resetValidation()
			}
		})
	}

	reset() {
		this.forEachChild(this, (child: Validatable) => {
			if (child.reset instanceof Function) {
				child.reset()
			}
		})
	}

	forEachChild<V extends Vue, T extends Vue>(vm: V, handler: (child: T) => void) {
		vm.$children.forEach(child => {
			handler(child as T)
			if (child.$children.length > 0) {
				this.forEachChild(child, handler)
			}
		})
	}

	private async onSubmit() {
		const isValid = await this.validate()
		if (isValid) {
			this.$emit('submit')
		}
	}

	private async onReset() {
		this.$emit('reset')
		await this.$nextTick()
		this.resetValidation()
	}
}
